<template>
  <Modal v-model="open" :title="title" width="800">
    <div class="text-manager">
      <div class="text-list">
        <div v-for="(text, index) in texts" :key="index" class="text-item">
          <Input v-model="texts[index]" placeholder="请输入文案内容" />
          <div class="text-actions">
            <Button type="error" size="small" @click="removeText(index)">删除</Button>
          </div>
        </div>
        <div class="add-text">
          <Button type="primary" @click="addText">添加文案</Button>
        </div>
      </div>
    </div>
    <div slot="footer" style="text-align: center">
      <Button @click="cancel">关闭</Button>
      <Button type="primary" :loading="loading" @click="save">保存</Button>
    </div>
  </Modal>
</template>

<script>
import { editArea } from '@/api/area'

export default {
  name: 'TextManager',
  data() {
    return {
      open: false,
      title: '文案管理',
      loading: false,
      texts: [],
      areaId: null
    }
  },
  methods: {
    init(params) {
      this.areaId = params.area_id
      this.getTexts()
      this.open = true
    },

    getTexts() {
      // 从区域数据中获取文案列表
      const area = JSON.parse(this.$store.state.areas).find(a => a.area_id == this.areaId)
      if (area) {
        this.texts = area.texts || []
      }
    },

    addText() {
      this.texts.push('')
    },

    removeText(index) {
      this.texts.splice(index, 1)
    },

    save() {
      this.loading = true
      const areas = JSON.parse(this.$store.state.areas)
      const area = areas.find(a => a.area_id == this.areaId)
      if (!area) {
        this.$Message.error('未找到区域数据')
        this.loading = false
        return
      }

      editArea({
        area_id: area.area_id,
        texts: this.texts
      })
        .then(res => {
          if (res.data.code == 200) {
            this.$Message.success('保存成功')
            // 更新store中的区域数据
            const index = areas.findIndex(a => a.area_id == this.areaId)
            if (index !== -1) {
              areas[index].texts = this.texts
              this.$store.commit('setareas', JSON.stringify(areas))
            }
            this.cancel()
            this.$emit('reload')
          } else {
            this.$Message.error(res.data.msg)
          }
        })
        .catch(err => {
          this.$Message.error(err)
        })
        .finally(() => {
          this.loading = false
        })
    },

    cancel() {
      this.open = false
      this.texts = []
      this.areaId = null
    }
  }
}
</script>

<style lang="less" scoped>
.text-manager {
  .text-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 16px;
    padding: 16px;

    .text-item {
      border: 1px solid #e8e8e8;
      border-radius: 4px;
      padding: 8px;
      display: flex;
      flex-direction: column;
      gap: 8px;

      .ivu-input-wrapper {
        width: 100%;
      }

      .text-actions {
        display: flex;
        gap: 8px;
        justify-content: center;
      }
    }

    .add-text {
      border: 1px dashed #d9d9d9;
      border-radius: 4px;
      padding: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100px;
      cursor: pointer;

      &:hover {
        border-color: #2d8cf0;
      }
    }
  }
}
</style> 